var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('footer',[_c('b-button',{attrs:{"href":"https://www.lifechanginginnovation.org/our-stories","target":"_blank"}},[_vm._v("Explore more stories of life-changing medical technology")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }